import {Entity, Cartesian3, PropertyBag} from 'cesium';
import {Label as getLabelStyle, Polygon as getStyle, setEntityStyle} from '../renderer';

export default class Polygon extends Entity {
    constructor(options) {
        const {geometry, properties, style, label, ...other} = options;
        let radius = geometry[2];
        let props = {
            // clampToGround: true,
            position: Cartesian3.fromDegrees(geometry[0], geometry[1]),
            ellipse: {
                semiMinorAxis: radius,
                semiMajorAxis: radius,
                ...getStyle({...style}),
            },
            ...other,
        };

        // 添加label
        if (label?.text) {
            props.label = getLabelStyle(label);
        }

        super(props);
    }

    setGeometry(geometry) {
        this.ellipse.hierarchy._value.positions.positions = Cartesian3.fromDegreesArray(
            geometry.flat(Infinity),
        );
    }

    setProperties(properties) {
        this.properties.setValue(new PropertyBag(properties));
        this.ellipse.properties.setValue(new PropertyBag(properties));
    }

    setLabel(label) {
        this.label.setValue(getLabelStyle(label))
    }

    setStyle(style) {
        setEntityStyle(this.ellipse, getStyle({...style}));
    }
}
